import React from "react";
import {Helmet} from "react-helmet-async";
import {Link} from "react-router-dom";

const SLIDES_URL = "https://produkacja.s3.eu-central-1.amazonaws.com/webinar/en-webinar/%5BEN%5D+Webinar+Jamie+Mik.pdf";
const BEST_SELF_URL = "https://docs.google.com/document/d/13Kjhekd2dh-hMsarwKST5CcgSZzhl7N3w7MezJ95LtA/edit?usp=sharing";

const cardStyle: React.CSSProperties = {
    background: "linear-gradient(145deg, rgba(42, 51, 66, 0.45) 0%, rgba(26, 26, 46, 0.65) 100%)",
    border: "1px solid rgba(42, 209, 103, 0.18)",
    borderRadius: 16,
    padding: "1.75rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
};

const ctaStyle: React.CSSProperties = {
    display: "inline-flex", alignItems: "center", gap: "0.5rem",
    padding: "0.75rem 1.25rem", borderRadius: 10, fontWeight: 700,
    background: "#2ad167", color: "#0b1410", textDecoration: "none",
    width: "fit-content",
};

export default function SlidesPage(): JSX.Element {
    return (
        <>
            <Helmet>
                <title>Training resources — Effective Action System</title>
                <meta name="robots" content="noindex"/>
            </Helmet>
            <main style={{
                minHeight: "100vh", background: "#0b1410", color: "#fff",
                padding: "4rem 1.5rem", display: "flex", justifyContent: "center",
            }}>
                <div style={{maxWidth: 720, width: "100%"}}>
                    <h1 style={{fontSize: "2rem", fontWeight: 700, marginBottom: "0.5rem"}}>
                        Training resources
                    </h1>
                    <p style={{color: "rgba(255,255,255,0.7)", marginBottom: "2rem", lineHeight: 1.6}}>
                        Slides from the training and the Best Self worksheet — yours to keep.
                    </p>

                    <div style={{display: "flex", flexDirection: "column", gap: "1.25rem"}}>
                        <section style={cardStyle}>
                            <div style={{fontSize: "0.85rem", color: "#2ad167", fontWeight: 600, letterSpacing: "0.04em"}}>
                                SLIDES
                            </div>
                            <h2 style={{fontSize: "1.25rem", fontWeight: 700, margin: 0}}>
                                Webinar slides (PDF)
                            </h2>
                            <p style={{color: "rgba(255,255,255,0.7)", margin: 0, lineHeight: 1.55}}>
                                The full deck from the training with Mik and Jamie. Save it,
                                review it, share it with your teen.
                            </p>
                            <a href={SLIDES_URL} target="_blank" rel="noopener noreferrer" style={ctaStyle}>
                                <i className="bi bi-file-earmark-pdf"></i>
                                Download slides
                            </a>
                        </section>

                        <section style={cardStyle}>
                            <div style={{fontSize: "0.85rem", color: "#2ad167", fontWeight: 600, letterSpacing: "0.04em"}}>
                                WORKSHEET
                            </div>
                            <h2 style={{fontSize: "1.25rem", fontWeight: 700, margin: 0}}>
                                Best Self worksheet
                            </h2>
                            <p style={{color: "rgba(255,255,255,0.7)", margin: 0, lineHeight: 1.55}}>
                                The exercise we walked through on the training. Open it in Google
                                Docs, then File → Make a copy to fill it in.
                            </p>
                            <a href={BEST_SELF_URL} target="_blank" rel="noopener noreferrer" style={ctaStyle}>
                                <i className="bi bi-file-earmark-text"></i>
                                Open Best Self worksheet
                            </a>
                        </section>
                    </div>

                    <div style={{marginTop: "2.5rem", fontSize: "0.9rem"}}>
                        <Link to="/" style={{color: "#2ad167", textDecoration: "underline"}}>
                            ← Back to home
                        </Link>
                    </div>
                </div>
            </main>
        </>
    );
}
